<template>
    <div class="app-body-container" style="padding-bottom: 30px">

        <!--条件区-->
        <el-row class="mg-t-10">
            <el-col :span="24">
                <el-card shadow="hover" class="mycard-a forecast-card">

                    <!--标题-->
                    <div class="forecast-title">欢迎使用Sysale Robot 库存预测</div>
                    <div class="forecast-subtitle">掌握未来库存，调整当前计划</div>

                </el-card>
            </el-col>
        </el-row>

        <!--列表-->
        <el-row class="mg-t-10">
            <el-col :span="24">
                <el-card shadow="hover" class="mycard-a">
                  <el-form :inline="true" class="myform inventory-search-form">
                    <el-form-item label="仓库">
                      <el-select placeholder="请选择" v-model="main$query_whId">
                        <el-option v-for="(item,idx) in data_warehouse" :key="idx" :label="item.whName" :value="item.whId"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="品牌">
                      <el-select placeholder="请选择" v-model="main$query_brandId">
                        <el-option v-for="(item,idx) in data_brand" :key="idx" :label="item.brandName" :value="item.brandId"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="商品">
                      <el-input placeholder="商品名称/条码/货号/规格" v-model="main$query_name"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="queryStockPrediction">搜索</el-button>
                    </el-form-item>
                  </el-form>

                    <!--表格、分页-->
                    <div style="padding: 0px 20px">
                        <el-table :data="tableKc" size="medium">
                            <el-table-column label="商品" width="220" align="center" header-align="center">
                              <template slot-scope="scope">
                                {{scope.row.goodsName}}
                              </template>
                            </el-table-column>
                            <el-table-column label="条码货号" width="180" align="center" header-align="center">
                              <template slot-scope="scope">
                                {{scope.row.barcode}}
                              </template>
                            </el-table-column>
                            <el-table-column label="规格" width="140" align="center" header-align="center">
                              <template slot-scope="scope">
                                {{scope.row.skuVname}}
                              </template>
                            </el-table-column>
                            <el-table-column label="单位" width="140" align="center" header-align="center">
                              <template slot-scope="scope">
                                {{scope.row.unitName}}
                              </template>
                            </el-table-column>
                            <el-table-column label="当前库存量" align="center" header-align="center">
                              <template slot-scope="scope">
                                {{scope.row.stocks}}
                              </template>
                            </el-table-column>
                            <el-table-column label="预计消化天数" align="center" header-align="center">
                              <template slot-scope="scope">
                                {{scope.row.cycle}}
                              </template>
                            </el-table-column>
                            <el-table-column label="预计库存日期" align="center" header-align="center" width="180">
                              <template slot-scope="scope">
                                <el-date-picker
                                  v-model="scope.row.foreDateFmt"
                                  type="date"
                                  placeholder="选择日期"
                                  @change="selectionDate(scope.$index, scope.row)"
                                  value-format="yyyy-MM-dd"
                                  style="width: 150px">
                                </el-date-picker>
                              </template>
                            </el-table-column>
                            <el-table-column label="预测库存量" align="center" header-align="center">
                              <template slot-scope="scope">
                                {{scope.row.surplus}}
                              </template>
                            </el-table-column>
                        </el-table>

                        <!--订单记录(分页)-->
                        <div style="margin: 14px">
                          <el-pagination style="float: right"
                                         background
                                         layout="total, sizes, prev, pager, next"
                                         :page-size="main$page_size"
                                         :current-page="main$curr_page"
                                         :total="main$total"
                                         @current-change="handlePageChange"></el-pagination>
                          <div style="clear: both"></div>
                        </div>
                    </div>

                </el-card>
            </el-col>
        </el-row>

    </div>
</template>

<script>
  import ElRow from "element-ui/packages/row/src/row";
export default {
  components: {ElRow},
  data: function () {
        return {
          tableKc:[], //数据列表
          // 下拉框数据
          data_warehouse:[],
          data_brand:[],
          // 表格数据
          main$query_whId: '',
          main$query_brandId: '',
          main$query_name: '',

          main$page_size: 10,
          main$curr_page: 1,
          main$total: 0,
        }
    },
    methods: {
      //查询库存预测
      queryStockPrediction(){
        let self = this;
        let post = {
          "page":self.main$curr_page,//分页页数
          "rows":self.main$page_size,//分页大小
          "dataSource":"01",//数据来源，01表示逍逍
          "whId":self.main$query_whId,//仓库ID
          "catId":"",//分类ID，前后加英文逗号
          "brandId":self.main$query_brandId,//品牌ID
          "name":self.main$query_name //商品名/条码/编码/规格
        };
        self.xFetch.post(self.xApi('/robot/stock/getGoodsForecastPage'), post).then(function (res) {
//          console.log(res.data);
          if(res.data.code=='00'){
            self.main$total = res.data.total;
            self.tableKc=res.data.rows
          }
        });
      },
      handlePageChange: function (val) {
        this.main$curr_page = val;
        this.queryStockPrediction();
      },
      //选择日期 库存预测
      selectionDate(index,row){
        let self = this;
        self.xFetch.post(self.xApi('/robot/stock/getStockForecast?dataSource=01&skuIds='+[row.skuId].join(',')+'&date='+row.foreDateFmt)).then(function (res) {
//          console.log(res.data);
          if(res.data.code=='00'){
            self.tableKc[index].surplus=res.data.data.forecast[0].surplus
          }
        });
      },
    },
    created: function(){
      let self = this;
      // 下拉框数据 仓库、品牌
      self.xFetch.post(self.xApi('/robot/common/getWarehouse'), {}).then(function (res) {
        if (res.data.code != '00') {
          self.xEui.msg_error(res.data.text)
          return
        }
        self.data_warehouse = res.data.data;
      });
      self.xFetch.post(self.xApi('/robot/common/getBrand'), {}).then(function (res) {
        if (res.data.code != '00') {
          self.xEui.msg_error(res.data.text)
          return
        }
        self.data_brand = res.data.data;
      });
      self.queryStockPrediction(); //查询库存预测
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /*forecast-card*/
    .forecast-card{ background: #409EFF; }
    .forecast-card .forecast-title{ font-size: 30px;color: #fff;text-align: center;margin-top: 52px }
    .forecast-card .forecast-subtitle{ font-size: 18px;color: #fff ;text-align: center;margin-top: 22px;margin-bottom: 22px}
    /*inventory-search-form*/
    .inventory-search-form{ padding: 15px 0px }
</style>
<style>
    /*forecast-card*/
    .forecast-card .el-form{ width: 300px;margin: 0 auto ;padding-bottom: 30px}
    .forecast-card .el-form .el-form-item__label{ font-size: 15px;color: #fff }
    .forecast-card .el-form .el-form-item{ margin-bottom: 14px; }
    .forecast-card .el-button{ width: 100%;background: #0061EE;border-color: #0061EE; }
    /*inventory-search-form*/
    .inventory-search-form .el-select{ width: 180px }
    .inventory-search-form .el-select .el-input{ width: 100% }
    .inventory-search-form .el-input{ width: 250px }
</style>



// WEBPACK FOOTER //
// src/views/inventory/forecast.vue